import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { ArticleSpeechSkipContainer } from "~/components/article/article-speech/article-speech-skip-container";
import { ZIndexLayer } from "~/lib/styles";
import type { articleSpeechInlineWidgetArticle$key } from "~/queries/__generated__/articleSpeechInlineWidgetArticle.graphql";

import { ArticleSpeechInlineWidgetGeneric } from "./variants/generic";
import type { HeadphoneIconTheme } from "./variants/generic/button/headphone-icon";
import { ArticleSpeechInlineWidgetPosties } from "./variants/posties";

export type ArticleSpeechInlineWidgetProps = {
  className?: string;
  headphoneIconTheme?: HeadphoneIconTheme;
  onClick?: () => void;
  reference: articleSpeechInlineWidgetArticle$key;
  variant: "posties" | "generic" | "generic-minify";
  withMinifyText?: boolean;
  zIndex?: string;
};

export const ArticleSpeechInlineWidget: FunctionComponent<ArticleSpeechInlineWidgetProps> = ({
  className,
  headphoneIconTheme = "grey",
  onClick,
  reference,
  variant,
  withMinifyText = true,
  zIndex = `${ZIndexLayer.Drawer - 1}`,
}) => {
  const article = useFragment(
    graphql`
      fragment articleSpeechInlineWidgetArticle on Article {
        ...genericArticleSpeechInlineWidgetGenericArticle
      }
    `,
    reference,
  );

  const handleRenderInlineWidget = () => {
    switch (variant) {
      case "posties":
        return <ArticleSpeechInlineWidgetPosties className={className} />;
      case "generic-minify":
        return (
          <ArticleSpeechInlineWidgetGeneric
            className={className}
            extendClick={onClick}
            headphoneIconTheme={headphoneIconTheme}
            isMinify={true}
            reference={article}
            withMinifyText={withMinifyText}
            zIndex={zIndex}
          />
        );
      default:
        return (
          <ArticleSpeechInlineWidgetGeneric
            className={className}
            extendClick={onClick}
            headphoneIconTheme={headphoneIconTheme}
            reference={article}
            zIndex={zIndex}
          />
        );
    }
  };
  return <ArticleSpeechSkipContainer>{handleRenderInlineWidget()}</ArticleSpeechSkipContainer>;
};

ArticleSpeechInlineWidget.displayName = "ArticleSpeechInlineWidget";
